<template>
  <div class="container d-flex flex-column justify-content-center">
    <div class="d-flex flex-column align-items-center">
      <nav
        class="navbar navbar-expand-lg navbar-light menu-bg p-0">
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav justify-content-center">
            <li
              class="nav-item active menu-text-padding
              d-flex align-items-center justify-content-center"
            >
              <router-link :to="{ path: '/home' }">
                <font-awesome-icon class="home-button" :icon="['fa', 'home']" />
              </router-link>
            </li>
            <!-- <li class="nav-item menu-text-padding">
              <router-link :to="{ path: '/download' }">
                <div class="menu-text nav-link">ดาวน์โหลด</div>
              </router-link>
            </li> -->
            <li class="nav-item dropdown menu-text-padding">
              <router-link :to="{ path: '/home' }"></router-link>
              <a
                class="nav-link dropdown-toggle menu-text"
                href=""
                id="navbarDropdown"
                role="button"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                >กติกาการเล่นเกมส์</a
              >
              <div
                class="dropdown-menu"
                style="background-color:#0c5941;"
                aria-labelledby="navbarDropdown"
              >
                <router-link
                  v-for="(item, i) in dropdownRule"
                  :key="i"
                  class="dropdown-item menu-text"
                  :to="{ path: item.path }"
                  >{{item.name}}</router-link
                >
              </div>
            </li>
            <li class="nav-item menu-text-padding">
              <router-link :to="{ path: '/faq' }">
                <div class="menu-text nav-link">คำถามที่พบบ่อย</div>
              </router-link>
            </li>
            <li class="nav-item menu-text-padding">
              <router-link :to="{ path: '/security' }">
                <div class="menu-text nav-link">ความปลอดภัย</div>
              </router-link>
            </li>
            <li class="nav-item menu-text-padding">
              <router-link :to="{ path: '/termofuse' }">
                <div class="menu-text nav-link">การใช้งาน</div>
              </router-link>
            </li>
            <li  class="nav-item menu-text-padding">
              <router-link :to="{ path: '/contactus' }">
                <div class="menu-text nav-link">ติดต่อเรา</div>
              </router-link>
            </li>
          </ul>
          <form class="form-inline my-2 my-lg-0"></form>
        </div>
      </nav>
      <!-- <div class="gradient-bottom-menu"></div> -->
    </div>
  </div>
</template>

<script>
import utils from '../services/utils';

export default {
  name: 'webmenu',
  data() {
    return {
      source: utils.getUserPersistent().user.source,
      dropdownRule: [
        {
          path: '/rule/ntpp',
          name: 'น้ำเต้าปูปลา',
        },
        {
          path: '/rule/tk_2cards',
          name: 'ตีไก่ 2 ใบ',
        },
        {
          path: '/rule/tk_3cards',
          name: 'ตีไก่ 3 ใบ',
        },
        {
          path: '/rule/13cardspoker',
          name: 'ไพ่สามกอง',
        },
        {
          path: '/rule/6cardspoker',
          name: 'ไพ่ 6 ใบ',
        },
        {
          path: '/rule/pokdeng',
          name: 'ป๊อกเด้ง',
        },
        {
          path: '/rule/pokdeng2',
          name: 'ป๊อกเด้ง2',
        },
        {
          path: '/rule/11hilo',
          name: 'ไฮโล',
        },
        {
          path: '/rule/brp',
          name: 'เป่ายิงฉุบไม่มีเจ้า',
        },
        {
          path: '/rule/brb',
          name: 'เป่ายิงฉุบมีเจ้า',
        },
        {
          path: '/rule/punpae',
          name: 'ปั่นแปะ',
        },
        {
          path: '/rule/paikang',
          name: 'ไพ่แคง',
        },
        {
          path: '/rule/bingo',
          name: 'บิงโก',
        },
        {
          path: '/rule/bingo2',
          name: 'บิงโก 2',
        },
        {
          path: '/rule/football',
          name: 'นักเตะลูกหนังในตำนาน',
        },
        {
          path: '/rule/fruitslot',
          name: 'ฟรุตลูเรตสลอต',
        },
        {
          path: '/rule/fishing',
          name: 'ทุ่งรักนักตกปลา',
        },
        {
          path: '/rule/horseracing',
          name: 'เกมส์แข่งม้า',
        },
        {
          path: '/rule/dragontiger',
          name: 'เสือมังกร',
        },
        {
          path: '/rule/baccarat',
          name: 'บาคาร่า',
        },
      ],
    };
  },
};
</script>

<style scoped>
.menu-bg {
  font-family: "Prompt", sans-serif;
  width: 80%;
  height: auto;
  /* background-color: rgb(0, 143, 107); */
  background-image: linear-gradient(
    to bottom,
    rgb(0, 143, 107),
    rgb(0, 113, 107)
  );
  border-radius: 5px 5px 0px 0px;
}
.menu-bg-img {
  border-radius: 5px 5px 0px 0px;
  width: 80%;
  height: auto;
  background-color: #0c5941;
}
.home-btn {
  background-image: url("../assets/hom-03.png");
  width: 1.5em;
  height: 1.5em;
  background-position: initial;
  position: relative;
  background-size: contain;
  background-repeat: no-repeat;
  /* margin-top: 15px; */
}
.home-btn:hover {
  background-image: url("../assets/hom-02.png");
}
.menu-text {
  color: rgb(253, 230, 12) !important;
  font-weight: bold;
  font-size: 1vw;
  margin-top: 5px;
  text-decoration: none;
}
.menu-text:hover {
  color: black !important;
  font-size: 1vw;
}
.menu-gamesrule-text {
  color: white;
  font-weight: bold;
  font-size: 1vw;
  margin-top: 5px;
}
.gamesrule-dropdown-content {
  display: none;
  position: absolute;
  background-color: #0c5941;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  text-align: left;
}
.gamesrule-dropdown-content a {
  color: white;
  padding: 12px 16px;
  text-decoration: none;
  font-size: 12px;
  display: block;
  font-weight: bold;
}
.gamesrule-dropdown-content a:hover {
  background-color: #ddd;
}
.gamesrule-dropdown:hover .gamesrule-dropdown-content {
  display: block;
}
.gamesrule-dropdown:hover .menu-gamesrule-text {
  color: #3e8e41;
}
.menu-text-padding {
  padding: 0rem 1.1rem 0rem 1.1rem;
}
.navbar-toggler-icon {
  width: 0.5em;
  height: 0.5em;
}
.gradient-bottom-menu {
  width: 80%;
  background-image: linear-gradient(to right, #f9ca24, #f6e58d, #f9ca24);
  height: 0.2em;
}
a {
  text-decoration: none;
}
.home-button {
  font-size: 1.5vw;
  color: rgb(253, 230, 12);
}
.home-button:hover {
  font-size: 1.5vw;
  color: black;
}
</style>
